import { useEffect, useRef } from "react";
import { useFrame, useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import type { Mesh } from "three";
import modelPath from "../../assets/3D-Model/678197dbd86b55e2cf637263.glb";

function Model3D() {
  const gltf = useLoader(GLTFLoader, modelPath);
  const meshRef = useRef<Mesh>(null);
  const scrollYRef = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      scrollYRef.current = window.scrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useFrame(() => {
    if (meshRef.current) {
      meshRef.current.rotation.y = scrollYRef.current / 90;
      meshRef.current.position.y = -(scrollYRef.current / 150);
    }
  });

  return (
    <mesh ref={meshRef} scale={[6, 6, 6]}>
      <primitive object={gltf.scene} />
    </mesh>
  );
}

export default Model3D;
